module.exports = function() {
  return new Worker("/" + "sass-transpiler.d0a9e805.worker.js");
};